import { z } from 'zod'

import { REQUIRED_FIELD_MESSAGE } from '@/constants'

export const deliveryAddressSchema = z.object({
  address: z
    .string({ required_error: REQUIRED_FIELD_MESSAGE })
    .trim()
    .min(1, REQUIRED_FIELD_MESSAGE),
})

export type DeliveryAddressFormType = z.infer<typeof deliveryAddressSchema>
